import React from 'react';
import { Form, Input, Table, Button } from 'antd';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import axios from 'axios';

import apiPath from 'apiPath';

class AddRole extends React.Component {

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
                this.props.form.resetFields();
            } else {
                console.log(err);
            }
        });
    }

    render() {

        let columns = [
            { title: 'Role', dataIndex: 'name' },
            { title: 'Creator', dataIndex: 'creator' },
            {
                title: 'Edit Role', dataIndex: 'id',
                render: (value) => <Button id={value} type='primary' onClick={this.props.getSelectedRole} >Edit</Button>
            }
        ];

        const { getFieldDecorator } = this.props.form;

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Item>
                    {getFieldDecorator('name', {
                        initialValue: '',
                    })(
                        <Input style={{ width: '60%', margin: '10px 10px 5px 20px' }} placeholder="Add role here" />
                    )}
                </Form.Item>
                <SaveButton buttonText="Add Role" style={{ textAlign: 'left', paddingLeft: '15pt' }} />
                <Table
                    bordered
                    size="medium"
                    dataSource={this.props.Roles}
                    style={{ backgroundColor: 'white', width: '80%', margin: '20px' }}
                    rowKey="Name"
                    columns={columns}
                    pagination={false} />
            </Form>
        );
    }
}

export default withSpin(Form.create()(AddRole));



// WEBPACK FOOTER //
// ./portal-components/Portal/AdminRole/AddRole.jsx